import common from './common';
import home from './home';
import products from './products';
import uses from './uses';
import ordering from './ordering';
import trueCinnamon from './trueCinnamon';
import contact from './contact';
import photoAlts from './photoAlts';

const content = { common, home, products, uses, ordering, trueCinnamon, contact, photoAlts };

export default content;
